import { useState, useEffect, KeyboardEvent } from 'react'

interface ChatInputProps {
  onSendMessage: (message: string) => void
  disabled?: boolean
  placeholder?: string
  initialValue?: string
}

export default function ChatInput({ onSendMessage, disabled, placeholder, initialValue = '' }: ChatInputProps) {
  const [message, setMessage] = useState(initialValue)

  useEffect(() => {
    console.log('ChatInput initialValue changed:', initialValue?.substring(0, 50) + '...')
    if (initialValue) {
      setMessage(initialValue)
    }
  }, [initialValue])

  const handleSend = () => {
    console.log('handleSend called, message:', message, 'disabled:', disabled)
    if (message.trim() && !disabled) {
      onSendMessage(message)
      setMessage('')
    } else {
      console.log('Send blocked - empty message or disabled')
    }
  }

  const handleKeyPress = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSend()
    }
  }

  return (
    <div className="border-t p-4">
      <div className="flex space-x-2">
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={placeholder || 'Type your message...'}
          disabled={disabled}
          rows={2}
          className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none disabled:bg-gray-50 disabled:cursor-not-allowed"
        />
        <button
          onClick={handleSend}
          disabled={disabled || !message.trim()}
          className="px-6 py-2 bg-[#0066CC] text-white rounded-lg hover:bg-[#004499] transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
        >
          Send
        </button>
      </div>
    </div>
  )
}